import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from 'src/app/utils/app-settings';
import { OnlineMeeting } from '../models/online-meeting';

@Injectable({
  providedIn: 'root'
})
export class OnlineMeetingsService {

  constructor(public http: HttpClient) { }

  getJoinUrlForEvent(eventOccurrenceId: number): Observable<string> {
    return this.http.get<string>(`${AppSettings.apiUrl}onlinemeeting/event/${eventOccurrenceId}/join`);
  }

  getJoinUrlByMeetingID(meetingId: number): Observable<string> {
    return this.http.get<string>(`${AppSettings.apiUrl}onlinemeeting/${meetingId}/join`);
  }

  getUpcomingMeetings(): Observable<Array<OnlineMeeting>> {
    return this.http.get<Array<OnlineMeeting>>(`${AppSettings.apiUrl}onlinemeeting/upcoming/student`);
  }
}
